// extracted by mini-css-extract-plugin
export default {"hotspotWrapper":"_3be92cc7","fadeIn":"_bb8fb03e","hotspot":"_2e3ce534","swell":"_98b7517e","pulse":"_9d003e40","quickViewLoaderIcon":"_cee4f6cd"};